import { render, staticRenderFns } from "./c_title.vue?vue&type=template&id=c1a60220&scoped=true"
import script from "./c_title.vue?vue&type=script&lang=js"
export * from "./c_title.vue?vue&type=script&lang=js"
import style0 from "./c_title.vue?vue&type=style&index=0&id=c1a60220&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a60220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1a60220')) {
      api.createRecord('c1a60220', component.options)
    } else {
      api.reload('c1a60220', component.options)
    }
    module.hot.accept("./c_title.vue?vue&type=template&id=c1a60220&scoped=true", function () {
      api.rerender('c1a60220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_title.vue"
export default component.exports